import { documentStatus } from "../constants/statusConstants";

const getNextDocumentStatus = (id: any) => {
  switch (id) {
    case documentStatus.new.id:
      return documentStatus.compose;
    case documentStatus.compose.id:
      return documentStatus.feedback;
    case documentStatus.feedback.id:
      return documentStatus.review;
    case documentStatus.review.id:
      return documentStatus.check;
    case documentStatus.check.id:
      return documentStatus.interimpublish;
    case documentStatus.interimpublish.id:
      return documentStatus.approval;
    case documentStatus.approval.id:
      return documentStatus.readytopublish;
    case documentStatus.readytopublish.id:
      return documentStatus.publish;
    case documentStatus.publish.id:
      return documentStatus.publish;
    default:
      return documentStatus.new;
  }
};

const getDocumentStatus = (id: any) => {
  switch (id) {
    case documentStatus.new.id:
      return documentStatus.new;
    case documentStatus.compose.id:
      return documentStatus.compose;
    case documentStatus.feedback.id:
      return documentStatus.feedback;
    case documentStatus.review.id:
      return documentStatus.review;
    case documentStatus.check.id:
      return documentStatus.check;
    case documentStatus.interimpublish.id:
      return documentStatus.interimpublish;
    case documentStatus.approval.id:
      return documentStatus.approval;
    case documentStatus.readytopublish.id:
      return documentStatus.readytopublish;
    case documentStatus.publish.id:
      return documentStatus.publish;
    default:
      return documentStatus.new;
  }
};

const getDocumentStatusByValue = (value: any) => {
  switch (value) {
    case documentStatus.new.value:
      return documentStatus.new;
    case documentStatus.compose.value:
      return documentStatus.compose;
    case documentStatus.feedback.value:
      return documentStatus.feedback;
    case documentStatus.review.value:
      return documentStatus.review;
    case documentStatus.check.value:
      return documentStatus.check;
    case documentStatus.interimpublish.value:
      return documentStatus.interimpublish;
    case documentStatus.approval.value:
      return documentStatus.approval;
    case documentStatus.readytopublish.value:
      return documentStatus.readytopublish;
    case documentStatus.publish.value:
      return documentStatus.publish;
    default:
      return documentStatus.new;
  }
};

const getDocumentStatusTitle = (id: any) => {
  return getDocumentStatus(id).label;
};

const getDocumentStatusLabel = (value: string) => {
  return getDocumentStatusByValue(value).label;

}

export { getNextDocumentStatus, getDocumentStatusTitle, getDocumentStatus, getDocumentStatusLabel };
